import Polyfills from "./common/Polyfills";
import Globals from "./common/Globals";

import Utils from './common/Utils';

import Header from './components/Header';
import Footer from './components/Footer';

import Sliders from './components/Sliders';
import Menus from './components/Menus';

class Application {
    constructor() {
        new Polyfills();
        new Globals();
        this.initialize();
        this.init();
    }

    initialize() {
        if (Utils.isTouch()) {
            $('html').addClass('app-is-touch');
        }
    }

    static onDOMContentLoaded() {
        Utils.init();

        new Header();
        new Footer();
        Header.RWDMenu();

        new Sliders();
        new Menus();
    }

    static onLoad() {

    }

    static onResize() {

    }

    init() {
        document.addEventListener('DOMContentLoaded', () => {
            this.constructor.onDOMContentLoaded()
        }, false);

        window.onload = () => this.constructor.onLoad();

        window.onresize = () => this.constructor.onResize();
    }
}

const App = new Application();



// WEBPACK FOOTER //
// ./src/assets/js/App.js